export default "__VITE_ASSET__CFCoQEXu__"